var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback } from 'react';
import { useAriaLive } from '..';
import { defaultProps } from './LiveRegion';
import { isSameContent } from '../utils';
var AriaLive = function (_a) {
    var id = _a.id, role = _a.role, _b = _a.setting, setting = _b === void 0 ? defaultProps.setting : _b, ariaAtomic = _a.ariaAtomic, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, children = _a.children;
    var _c = useAriaLive(), announcePolite = _c.announcePolite, announceAssertive = _c.announceAssertive;
    var _d = __read(useState(undefined), 2), prevId = _d[0], setPrevId = _d[1];
    var _e = __read(useState(null), 2), prevChildren = _e[0], setPrevChildren = _e[1];
    var makeAnnouncement = useCallback(function () {
        if (setting !== 'off') {
            var config = { role: role, ariaAtomic: ariaAtomic, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy };
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (setting === 'polite')
                announcePolite(children, config);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (setting === 'assertive')
                announceAssertive(children, config);
        }
    }, [
        role,
        setting,
        ariaAtomic,
        ariaDescribedBy,
        ariaLabelledBy,
        children,
        announcePolite,
        announceAssertive,
    ]);
    /**
     * The useEffect hook doesn't have a sufficient check for element equality,
     * so we're performing a more thorough check for our own purposes.
     *
     * We're also including a manual check of the id because we want to make
     * an announcement if the id changed even if the children have not. We're not
     * monitoring the id in a separate useEffect hook to prevent potential double
     * announcements if both props have changed, or on initial mount.
     */
    useEffect(function () {
        if ((id && id !== prevId) || !isSameContent(prevChildren, children)) {
            makeAnnouncement();
        }
        setPrevId(id);
        setPrevChildren(children);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, children]);
    return React.createElement(React.Fragment, null, children);
};
export { AriaLive };
//# sourceMappingURL=AriaLive.js.map